import React from 'react';

export interface LoadState {
  isError: boolean;
  isLoaded: boolean;
}

interface Props {
  children(params: LoadState): JSX.Element;
  loadData(): Promise<any>;
  intervalMs?: number;
}

interface State {
  isError: boolean;
  isLoaded: boolean;
}

export class DataLoader extends React.Component<Props, State> {
  public state: State;

  private fetchTimer: number;

  constructor(props) {
    super(props);

    this.state = {
      isLoaded: false,
      isError: false,
    };
  }

  public fetchData() {
    const { loadData, intervalMs } = this.props;
    window.clearTimeout(this.fetchTimer);

    loadData().then(
      () => {
        this.setState({
          isLoaded: true,
        });

        if (typeof intervalMs !== 'undefined') {
          this.fetchTimer = window.setTimeout(() => {
            this.fetchData();
          }, intervalMs);
        }
      },
      () => {
        this.setState({
          isError: true,
        });

        window.clearTimeout(this.fetchTimer);
      },
    );
  }

  public componentWillUnmount(): void {
    window.clearTimeout(this.fetchTimer);
  }

  public componentDidMount() {
    this.fetchData();
  }

  public UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState(
      {
        isError: false,
        isLoaded: false,
      },
      () => {
        this.fetchData();
      },
    );
  }

  public render() {
    const { children } = this.props;
    const { isError, isLoaded } = this.state;

    return children({ isError, isLoaded });
  }
}
